import { ExportFormat, formattingPapers } from './paper-formatting';
import { Paper } from '../models/result-set';

interface ExportAllParams {
  type: 'export-all';
  query: string;
  papers: Paper[];
}

interface ExportSelectedParams {
  type: 'export-selected';
  query: string;
  papers: Paper[];
}

export type ExportParams = ExportAllParams | ExportSelectedParams;

interface MimeTypeAndExtension {
  mimeType: string;
  fileExtension: string;
}

const formatTypeToMimeType: Record<ExportFormat, MimeTypeAndExtension> = {
  json: { mimeType: 'application/json', fileExtension: 'json' },
  markdown: { mimeType: 'text/markdown', fileExtension: 'md' },
  bibtex: { mimeType: 'application/x-bibtex', fileExtension: 'bib' },
};

export function downloadPapers(
  exportParams: ExportParams,
  formatType: ExportFormat,
): void {
  const content = formattingPapers(
    exportParams.papers,
    exportParams.query,
    formatType,
  );
  const { mimeType, fileExtension } = formatTypeToMimeType[formatType];

  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `papers.${fileExtension}`;
  a.click();
  URL.revokeObjectURL(url);
  a.remove();
}
